module.exports = __webpack_public_path__ + "0389db2cce2d2b7b2ed100c03a3b37e4.svg";